var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcClat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1236_2420)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 56,
    height: 56,
    rx: 12,
    fill: "url(#paint0_linear_1236_2420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 18.5H42.0001C42.8298 18.5 43.5001 19.1703 43.5001 20C43.5001 20.8297 42.8298 21.5 42.0001 21.5H36.6751C36.4313 22.7094 35.6016 23.7078 34.5001 24.1859V38H42.0001C42.8298 38 43.5001 38.6703 43.5001 39.5C43.5001 40.3297 42.8298 41 42.0001 41H33.0001H24.0001C23.1704 41 22.5001 40.3297 22.5001 39.5C22.5001 38.6703 23.1704 38 24.0001 38H31.5001V24.1859C30.3985 23.7031 29.5688 22.7047 29.3251 21.5H24.0001C23.1704 21.5 22.5001 20.8297 22.5001 20C22.5001 19.1703 23.1704 18.5 24.0001 18.5H30.0001C30.6845 17.5906 31.772 17 33.0001 17C34.2282 17 35.3157 17.5906 36.0001 18.5ZM38.6063 32H45.3938L42.0001 26.1781L38.6063 32ZM42.0001 36.5C39.0516 36.5 36.6001 34.9062 36.0938 32.8016C35.972 32.2859 36.1407 31.7563 36.4079 31.2969L40.8704 23.6469C41.1048 23.2438 41.536 23 42.0001 23Cnan nan 42.8954 23.2484 43.1298 23.6469L47.5923 31.2969C47.8595 31.7563 48.0282 32.2859 47.9063 32.8016C47.4001 34.9062 44.9485 36.5 42.0001 36.5ZM23.9438 26.1781L20.5501 32H27.3423L23.9438 26.1781ZM18.0423 32.8016C17.9204 32.2859 18.0891 31.7563 18.3563 31.2969L22.8188 23.6469C23.0532 23.2438 23.4845 23 23.9485 23Cnan nan 24.8438 23.2484 25.0782 23.6469L29.5407 31.2969C29.8079 31.7563 29.9766 32.2859 29.8548 32.8016C29.3438 34.9062 26.8923 36.5 23.9438 36.5C20.9954 36.5 18.5485 34.9062 18.0423 32.8016Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1236_2420",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1236_2420"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1236_2420"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1236_2420"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1236_2420",
    result: "effect2_dropShadow_1236_2420"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1236_2420",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1236_2420",
    x1: 5,
    y1: 1,
    x2: 61,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D97706"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClat);
export default __webpack_public_path__ + "static/media/ic_clat.f93f6b300f1e84498e76690394d4263b.svg";
export { ForwardRef as ReactComponent };